import {EEntityType} from 'shared/constants/entities';
import {IMenuStructureItem} from 'store/slices/menu-slice/menu-slice-types';

import {IBreadcrumbItem} from '../breadcrumb';

const SHARED_BREADCRUMBS = [
    {
        name: 'Главная страница',
        path: '/',
    },
];

export const parseBreadcrumbsFromMenuItem = (
    menuStructureIdMap: Record<string, IMenuStructureItem> | null,
    menuItemName?: string,
    menuItemType?: EEntityType,
    menuItemEntityName?: string,
    parentItem?: IMenuStructureItem,
    url?: string,
): IBreadcrumbItem[] => {
    let breadcrumbs: IBreadcrumbItem[] = [...SHARED_BREADCRUMBS];

    // in case we on a page with crumbs support (e.g. TABLE) and should display crumbless component (e.g. TABLE_REPORT)
    const isUrlContainsId = url?.match(RegExp(`\\/${menuItemEntityName}\\/(.*)`));
    if (isUrlContainsId) {
        return [];
    }

    // Recursively add section breadcrumbs for the parent items
    const addParentBreadcrumbs = (item?: IMenuStructureItem) => {
        if (!item || !menuStructureIdMap) return;

        if (item.parentId) {
            const parent = menuStructureIdMap[item.parentId];
            addParentBreadcrumbs(parent);
        }

        breadcrumbs.push({name: item.itemTitle});
    };

    if (parentItem) {
        addParentBreadcrumbs(parentItem);
    }

    switch (menuItemType) {
    case EEntityType.JASPER_REPORT:
    case EEntityType.TABLE_REPORT:
        breadcrumbs = [];
        break;
    default:
        if (menuItemName && parentItem?.entityType !== EEntityType.TABS_WITH_REFERENCES) {
            breadcrumbs.push({name: menuItemName});
        }
    }

    return breadcrumbs;
};
